export default __webpack_public_path__ + "static/media/facebook.ad83798c.svg";